module.exports = __webpack_public_path__ + "static/media/story.48e86703.svg";